// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: 'AIzaSyDuwOse_20tPdW6h2XVKE5ISh3LDIBJWzc',
    authDomain: 'ahs-registration.firebaseapp.com',
    projectId: 'ahs-registration',
    storageBucket: 'ahs-registration.appspot.com',
    messagingSenderId: '767640576813',
    appId: '1:767640576813:web:fd137d599d0db4f03de9a4',
    measurementId: 'G-133ZQR0PQS'
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const functions = getFunctions(app);
